import Vue from 'vue';
import Vuex from 'vuex';
import product from './modules/product';
import user from './modules/user';
import expense from './modules/expense';
import role from './modules/role';
import attribute from './modules/attribute';
import supplier from './modules/supplier';
import paymentMode from './modules/paymentMode';
import tax from './modules/tax';
import sale from './modules/sale';
import invoice from './modules/invoice';
import creditNote from './modules/creditNote';
import service from './modules/service';
import serviceCategory from './modules/serviceCategory';
import serviceRequest from './modules/serviceRequest';
import serviceJob from './modules/serviceJob';
import status from './modules/status';
import vendor from './modules/vendor';
import vendorType from './modules/vendorType';
import serviceRequestJob from './modules/serviceRequestJob';
import serviceRequestQuotation from './modules/serviceRequestQuotation';
import serviceRequestTransaction from './modules/serviceRequestTransaction';
import serviceRequestChalan from './modules/serviceRequestChalan';
import laborCost from './modules/laborCost';
import serviceRequestLabor from './modules/serviceRequestLabor';
import job from './modules/job';
import noAuth from './modules/noAuth';

Vue.use(Vuex);

export default new Vuex.Store({
        modules: {
                product,
                user,
                expense,
                role,
                attribute,
                supplier,
                paymentMode,
                tax,
                sale,
                invoice,
                creditNote,
                serviceCategory,
                serviceRequest,
                service,
                status,
                serviceJob,
                vendor,
                vendorType,
                serviceRequestJob,
                serviceRequestQuotation,
                serviceRequestTransaction,
                serviceRequestChalan,
                laborCost,
                serviceRequestLabor,
                job,
                noAuth
        },
})
